import React from 'react';

const SVG = ({ style = {}, color, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <path fill={color} d="M97,97 73,97 73,73 75,97 27,97 27,73 27,97 5,97 C-1,51 28,46 35,41 C0,-10 100,-10 65,41 C72,46 101,51 95,97" />
    <g fill="none" stroke="white" strokeWidth="5">
      <path d="M97,97 73,97 73,73 75,97 27,97 27,73 27,97 5,97 C-1,51 28,46 35,41 M65,41 C72,46 101,51 95,97" />
      <circle cx="50" cy="25" r="22" />
    </g>
  </svg>
);

export default SVG;
